import { render, staticRenderFns } from "./upLoad.vue?vue&type=template&id=ecb96b0e&scoped=true&"
import script from "./upLoad.vue?vue&type=script&lang=js&"
export * from "./upLoad.vue?vue&type=script&lang=js&"
import style0 from "./upLoad.vue?vue&type=style&index=0&id=ecb96b0e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb96b0e",
  null
  
)

export default component.exports